import React from "react";
import H5ADLargeUploader from "../components/H5ADLargeUploader";

export default function LargeUploaderPage() {
  return (
    <div className="min-h-screen bg-gray-100 flex flex-col items-center justify-center p-6">
      <h1 className="text-2xl font-bold mb-4 text-center">📤 Upload Large File</h1>
      <H5ADLargeUploader />
    </div>
  );
}
